import { render } from "./FoodMenus.vue?vue&type=template&id=0d8abea6&scoped=true&ts=true"
import script from "./FoodMenus.vue?vue&type=script&lang=ts"
export * from "./FoodMenus.vue?vue&type=script&lang=ts"

import "./FoodMenus.vue?vue&type=style&index=0&id=0d8abea6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8abea6"]])

export default __exports__